import { render, staticRenderFns } from "./aiAdminSetup.vue?vue&type=template&id=b13c2a4e&scoped=true"
import script from "./aiAdminSetup.vue?vue&type=script&lang=js"
export * from "./aiAdminSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13c2a4e",
  null
  
)

export default component.exports